module.exports = __webpack_public_path__ + "img/business.8c50fa99.svg";